<span class="reference-field-label">{{ field.label }}</span>

<div class="field-wrapper">
  <div *ngIf="isSelectorAvailable" class="reference-selector-wrapper">
    <mat-select class="reference-selector" [(ngModel)]="selectedReference" (ngModelChange)="onReferenceChange()">
      <mat-option *ngFor="let item of field.referenceTo" [value]="item.value">{{item.name}}</mat-option>
    </mat-select>
  </div>

  <div class="magnifier-icon-wrapper">
    <svg-icon icon="magnifier"></svg-icon>
  </div>

  <input class="input-field"
         [ngClass]="{'input-field-reference-selector': isSelectorAvailable}"
         [ngbTypeahead]="onSearch"
         [editable]="false"
         [resultTemplate]="listItemTemplate"
         [inputFormatter]="formatItemWhenSelected"
         [value]="defaultItem?.label"
         (blur)="onBlur()"
         (selectItem)="onItemSelected($event.item)"
         #inputElement />
</div>

<div class="error-message" *ngIf="!isValid">{{ "salesforceReferenceField.required" | translate: { label: field.label } }}</div>
<div class="error-message" *ngIf="errorText">{{ errorText }}</div>

<ng-template #listItemTemplate let-item="result">
  {{ item.label }}
  <div *ngIf="multilineEnabled" class="template-value">{{ item.value }}</div>
</ng-template>
